import { useTranslation } from '../i18n';
import './LanguageSwitcher.css';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useTranslation();
  
  const flagUrls = {
    de: 'https://flagicons.lipis.dev/flags/4x3/de.svg',
    fr: 'https://flagicons.lipis.dev/flags/4x3/fr.svg'
  };
  
  const handleLanguageSwitch = () => {
    const button = document.querySelector('.language-button');
    const flag = document.querySelector('.flag');
    
    // Add animation class
    button.classList.add('switching');
    
    setTimeout(() => {
      const newLanguage = language === 'de' ? 'fr' : 'de';
      setLanguage(newLanguage);
      
      // Remove animation class after language change
      setTimeout(() => {
        button.classList.remove('switching');
      }, 300);
    }, 150);
  };
  
  return (
    <div className="language-switcher">
      <button
        onClick={handleLanguageSwitch}
        className="language-button"
        title={language === 'de' ? 'Switch to French' : 'Passer à l\'allemand'}
      >
        <img 
          src={flagUrls[language === 'de' ? 'fr' : 'de']} 
          alt={language === 'de' ? 'French flag' : 'German flag'}
          className="flag"
        />
      </button>
    </div>
  );
}